/**
 * Ценообразование: коэффициенты наценки и курсы по умолчанию.
 *
 * Единый источник истины для фронта и бэка. До этого модуля каждое место
 * считало себестоимость со своим зашитым фолбэком (1.4 в priceColDefs, 1.2 для
 * РФ в computeBestPrice, 12.5 для курса CNY) — коэффициенты разъехались, и КП
 * уходил клиенту по цене, которой не было ни в одном справочнике.
 */

/**
 * Коэффициент наценки по умолчанию — применяется ТОЛЬКО там, где в таблице
 * markup_constants нет строки для матрицы (серверный getMarkupConstants).
 * На фронте фолбэков быть не должно: незагруженный справочник = блок расчёта,
 * цены показываются прочерком, вход в режим КП закрыт.
 */
export const DEFAULT_MARKUP = 1.4

/** Ключи markup_constants по матрицам. */
export const MARKUP_KEYS = ['STOCK', 'CHINA', 'RF', 'MANUFACTURER', 'OTHER'] as const
export type MarkupKey = (typeof MARKUP_KEYS)[number]

/** Ключ матрицы в UI ('stock'|'china'|'rf'|'manuf'|'other') → ключ markup_constants. */
export const MARKUP_KEY_BY_MATRIX: Record<string, MarkupKey> = {
  stock: 'STOCK',
  china: 'CHINA',
  rf: 'RF',
  manuf: 'MANUFACTURER',
  other: 'OTHER',
}

/** Ключ матрицы в UI → sourceType квоты (он же ключ markup_constants). */
export const SOURCE_TYPE_BY_MATRIX: Record<string, MarkupKey> = MARKUP_KEY_BY_MATRIX

/** Ключ матрицы в UI → русская подпись (колонка таблицы, фолбэк поставщика). */
export const MATRIX_LABEL_BY_KEY: Record<string, string> = {
  stock: 'Склад',
  china: 'Китай',
  rf: 'РФ',
  manuf: 'Производители',
  other: 'Стоки',
}

/**
 * Курсы валют по умолчанию — только для серверного getExchangeRates (когда в
 * БД нет строки по валюте). На фронте подставлять их нельзя: см. DEFAULT_MARKUP.
 */
export const DEFAULT_EXCHANGE_RATES = { USD: 90, EUR: 98, CNY: 12.5 } as const
